import React, { useState, useMemo, createContext, useContext } from "react";
import { ThemeProvider, CssBaseline } from "@mui/material";
import getAdminTheme from "../../styles/AdminTheme";

const AdminThemeContext = createContext();

export const useAdminTheme = () => useContext(AdminThemeContext);

const AdminThemeProvider = ({ children }) => {
  const [mode, setMode] = useState(() => {
    return localStorage.getItem("admin-theme-mode") || "light";
  });

  const theme = useMemo(() => getAdminTheme(mode), [mode]);

  const toggleTheme = () => {
    const newMode = mode === "light" ? "dark" : "light";
    setMode(newMode);
    localStorage.setItem("admin-theme-mode", newMode);
  };

  return (
    <AdminThemeContext.Provider value={{ mode, toggleTheme }}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </AdminThemeContext.Provider>
  );
};

export default AdminThemeProvider;
